<div class="container mt-5 mt-lg-6" appAos>
    <div class="row">
        <div class="col text-center">
            <img class="w-75" src="assets/images/arrow-curly-down.svg" alt="Curly Arrow" />
        </div>
    </div>
</div>
